export default __webpack_public_path__ + "static/media/1619433038_mideaac.732a41cb.jpg";